import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=cb26bc38"
import script from "./TextAreaInput.vue?vue&type=script&lang=js"
export * from "./TextAreaInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports